import type { Participant } from "@/api/types";
import { avatarColour, avatarInitials, participantLabel } from "@/utils/avatar";
import "./avatar.css";

export type AvatarSize = "sm" | "md" | "lg";

export interface AvatarProps {
  participant: Pick<Participant, "name" | "display_suffix">;
  size?: AvatarSize;
  /** When provided, used as the rendered tooltip + a11y label. */
  title?: string;
}

export function Avatar({ participant, size = "md", title }: AvatarProps) {
  const label = title ?? participantLabel(participant);
  const initials = avatarInitials(participant);
  return (
    <span
      className={`wp-avatar wp-avatar--${size}`}
      style={{ ["--avatar-bg" as string]: avatarColour(participant.name) }}
      role="img"
      aria-label={label}
      title={label}
    >
      {initials}
    </span>
  );
}
